<template>
  <div style="width:100%;float:left;">
    <div class="pdfWrapper">
      <div style="width:100%;" v-if="showInvoice">
        <div style="width:100%;float:left;text-align:center;padding-top:10px;height:50px;">
          <CButton size="sm" @click="downloadInvoice" color="primary" style="margin-right:10px;">
            Download Invoice
          </CButton>
          <CButton size="sm" @click="close()" color="danger">Close</CButton>
        </div>

        <!-- TODO: add invoice data here: -->
        
        <iframe ref="pdfIframe" id="pdfIframe" width="100%" style="height:calc(100vh - 50px);" frameborder="0"></iframe>
      </div>
      <small-loader v-show="loading"></small-loader>
    </div>
    <!-- <iframe v-if="pdfUrl" :src="pdfUrl" width="100%" height="600px" frameborder="0"></iframe> -->
    <!-- <div style="width:100%;float:left;" v-if="data && invoiceData && !loading">
      <div class="row">
        <div class="col-12 text-right">
          <CButton size="sm" color="info" @click="sendInvoice()">Send Invoice Email</CButton>
        </div>
      </div>
      <spacer />
      <div class="row">
        <div class="col-4 float-left">
          <label class='boldHeader'>INVOICE</label>
        </div>
        <div class="col-4 float-left text-center">
          <label class='boldHeader'>IMPERIAL</label>
        </div>
        <div class="col-2 float-left">
          <label class='boldHeader'>INVOICE NO.</label>
        </div>
        <div class="col-2 float-left">
          <label class='boldHeader'>DATE</label>
        </div>
      </div>
      <div class="row">
        <div class="col-4 float-left">
          <label class='boldHeader'>Remit To</label>
        </div>
        <div class="col-4 float-left text-center">
          <label class='info'>
            PO Box 875035<br />
            Kansas City, MO 64187-5035
          </label>
        </div>
        <div class="col-2 float-left">
          <label class='info'>{{invoiceData.tranid}}</label>
        </div>
        <div class="col-2 float-left">
          <label class='info'>{{invoiceData.trandate}}</label>
        </div>
      </div>
      <div class="row">
        <div class="col-6 float-left">
          <div class="shippingBox">
            <div class="headerBox">SOLD TO</div>
            <div class="boxInfo">
              <label>{{data[0].billingaddress}}</label>
              <label>{{data[0].billaddressee || ''}}</label>
              <label>{{data[0].billattention || ''}}</label>
              <label>{{data[0].billaddr1 || ''}}</label>
              <label>{{data[0].billcity || ''}}, {{data[0].billstate || ''}} {{data[0].billzip || ''}}</label>
            </div>
          </div>
        </div>
        <div class="col-6 float-left">
          <div class="shippingBox">
            <div class="headerBox">SHIP TO</div>
            <div class="boxInfo">
              <label>{{data[0].shipaddressee || ''}}</label>
              <label>{{data[0].shipattention || ''}}</label>
              <label>{{data[0].shipaddr1 || ''}}</label>
              <label>{{data[0].shipcity || ''}}, {{data[0].shipstate || ''}} {{data[0].shipzip || ''}}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-3 float-left">
          <label class='boldHeader'>Order Number</label>
          <label class="info">{{data[0].orderid || ''}}</label>
        </div>
        <div class="col-3 float-left text-center">
          <label class='boldHeader'>ORDER DATE</label>
          <label class="info">{{data[0].orderdate || ''}}</label>
        </div>
        <div class="col-3 float-left">
          <label class='boldHeader'>ACCOUNT NUMBER</label>
          <label class="info">{{customer_selected.customer_number}}</label>
        </div>
        <div class="col-3 float-left">
          <label class='boldHeader'>SALESMAN</label>
          <label class="info">{{data[0].salesrepnumber || ''}}</label>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-3 float-left">
          <label class='boldHeader'>PO NUMBER</label>
          <label class="info">{{data[0].ponumber || ''}}</label>
        </div>
        <div class="col-3 float-left text-center">
          <label class='boldHeader'>TERMS</label>
          <label class="info">{{data[0].terms || ''}}</label>
        </div>
        <div class="col-3 float-left">
          <label class='boldHeader'>SHIP VIA</label>
          <label class="info">{{data[0].shippingmethod || ''}}</label>
        </div>
        <div class="col-3 float-left">
          <label class='boldHeader'>TRACKING #</label>
          <label class="info">{{data[0].trackingnumberlist || ''}}</label>
        </div>
      </div>
      <div class="row mt-3">
        <table class="table">
          <thead>
            <tr>
              <th>Quantity</th>
              <th>Item #</th>
              <th>Desc</th>
              <th>Color</th>
              <th>Unit Price</th>
              <th>Ext. Price</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="val in data">
              <td>{{val.quantity}}</td>
              <td>{{val.item || ''}}</td>
              <td></td>
              <td>{{val.custcol_mb_color || ''}}</td>
              <td>{{val.rate || ''}}</td>
              <td>{{val.amount || ''}}</td>
            </tr>
            <tr>
              <td colspan="5" style="text-align:right;">Sale Amount</td>
              <td>{{data[0].totalamount}}</td>
            </tr>
            <tr>
              <td colspan="5" style="text-align:right;">Freight</td>
              <td>{{data[0].shippingrate}}</td>
            </tr>
            <tr>
              <td colspan="5" style="text-align:right;">Pay This Amount</td>
              <td>{{data[0].amountunpaid}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row mt-3">
        <div class="col-3 float-left">
          <label class='boldHeader'>WEIGHT</label>
          <label class="info">{{data[0].weight || ''}}</label>
        </div>
        <div class="col-3 float-left text-center">
          <label class='boldHeader'>CARTONS</label>
          <label class="info">{{data[0].cartons || ''}}</label>
        </div>
      </div>
      <div class="row">
        <label class="info">***Currency is in US Dollars</label>
        <label class="info">"The goods covered in this invoice were produced in compliance with the fair labor standards act of 1938."</label>
        <label class="info">ALL CLAIMS MUST BE MADE WITHIN 10 DAYS OF RECEIPT OF GOODS. NO RETURNS WITHOUT WRITTEN CONSENT. ALL CORRESPONDENCE TO BE MADE DIRECTLY TO IMPERIAL HEADWEAR PO BOX 98 BOURBON, MO 65441.</label>
      </div>
    </div> -->
    
  </div>
</template>
<script>
var methods = {}

methods.popupModal = function (item) {
  console.log(item)
  this.invoiceData = item
  this.modal = true
}

methods.close = function () {
  this.showInvoice = false
  this.$emit('close')
}

methods.sendInvoice = function () {
  Swal.fire({
    title: 'Sorry..',
    text: 'This function is not yet setup through NetSuite.',
    type: 'danger'
  })
}

methods.getData = function () {
  this.showInvoice = false
  this.loading = true
  const postData = {
    invoiceData: this.invoiceData
  }
  console.log(postData)
  axios.post(this.$apiAdress + '/api/reports/getSpecificInvoicePdf?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    this.showInvoice = true
    // this.data = response.data.items
    // this.loading = false
    // const file = new Blob([response.data], { type: 'application/pdf' });
    // const fileURL = URL.createObjectURL(file);
    
    // // // Set the iframe src to the generated Blob URL
    // // window.open(fileURL)
    // // const iframe = document.querySelector('iframe');
    // if (iframe) {
    //   console.log(iframe)
    //   console.log(fileURL)
    //   console.log('yes')
    //   iframe.src = fileURL;
    // }
    // // const link = document.createElement('a');
    // // link.href = fileURL;
    // // link.download = 'invoice.pdf';  // Specify a file name
    // // link.click();

    // this.loading = false;
    var that = this
    setTimeout(function () {
      if (response.data.content) {
        // Convert Base64 to a binary Blob
        const pdfBase64 = response.data.content;
        const binary = atob(pdfBase64.replace(/\s/g, '')); // Base64 decode
        const len = binary.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          bytes[i] = binary.charCodeAt(i);
        }
        const file = new Blob([bytes.buffer], { type: 'application/pdf' });
        that.pdfBlob = file;
        const fileURL = URL.createObjectURL(file);

        // Set the Blob URL as the iframe source
        // const iframe = document.querySelector('iframe');
        const iframe = document.querySelector('#pdfIframe');
        if (iframe) {
          iframe.src = fileURL;
        }

        that.loading = false;
      }
    }, 500);
    // if (response.data.pdf) {
    //     // Base64 decode and create a Data URL for the PDF
    //     const base64PDF = response.data.pdf;
    //     const pdfDataUrl = `data:application/pdf;base64,${base64PDF}`;

    //     // Set the iframe src to the Data URL
    //     const iframe = document.querySelector('iframe');
    //     if (iframe) {
    //       iframe.src = pdfDataUrl;
    //     }

    //     this.loading = false;
    //   }
  })
}

methods.downloadInvoice = function () {
  if (!this.pdfBlob) return
  const url = URL.createObjectURL(this.pdfBlob)
  const a = document.createElement('a')
  a.href = url
  const name = (this.invoiceData && this.invoiceData.invoice_number) ? this.invoiceData.invoice_number : 'invoice'
  a.download = name + '.pdf'
  a.click()
  URL.revokeObjectURL(url)
}



export default {
  // ===Component name
  name: "CustomerInvoice",
  // ===Props passed to component
  props: ['invoiceData', 'customer_selected'],
  // ===Components used by this component
  components: {

  },
  // ====component Data properties
  data(){
      return{
        data: '',
        modal: false,
        loading: true,
        showInvoice: false,
        pdfUrl: '',
        pdfBlob: null
      }
  },
  // ===Code to be executed when Component is mounted
  mounted() {
    this.showInvoice = false
    this.getData()
    console.log(this.invoiceData)

    const token = localStorage.getItem('api_token');
    this.pdfUrl = `${this.$apiAdress}/api/reports/getSpecificInvoicePdf?token=${token}`;
  },
  // ===Computed properties for the component
  computed: {},
  // ===Component methods
  methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped lang="scss">
  .pdfWrapper {
    width: 100%;
    height: 100%;
    position:fixed;
    top:0;
    left:0;
    right:0;
    bottom:0;
    background-color: rgba(0,0,0,1);
    z-index:10000;

    #adobe-dc-view {
      width:100%;height:calc(100% - 100px);
    }
  }
  .bigLabel {
    font-size:18px;
  }

  .shippingBox {
    border: 1px solid black;
    width:100%;
    float:left;

    .headerBox {
      border-bottom: 1px solid black;
      width:100%;
      float:left;
      padding: 10px;
    }

    .boxInfo {
      width:100%;
      float:left;
      padding: 10px;

      label {
        width:100%;
        float:left;
      }
    }
  }

  .boldHeader {
    width: 100%;
    font-weight:800;
    float:left;
  }

  .info {
    width:100%;
    float:left;
  }

  .bold {
    font-weight: 800;
  }
  .data {
    font-weight: 800;
  }
  .tag {
    padding-left: 20px;
  }
  .tag, .data {
    margin-bottom: 7px;
    font-size: 14px;
  }
  .number {
    text-align: right;
  }
</style>
